import { jsx as n } from "react/jsx-runtime";
import { c as y } from "./clsx-OuTLNxxd.js";
import { c as t } from "./index-DpeO8ABv.js";
import "./Badge.css?__remix_sideEffect__";const c = "_badge_1yk1u_1",d = "_primary_1yk1u_11",m = "_secondary_1yk1u_17",u = "_error_1yk1u_23",z = "_isRound_1yk1u_36",s = {
    badge: c,
    primary: d,
    secondary: m,
    error: u,
    "size-xs": "_size-xs_1yk1u_29",
    isRound: z,
    "size-s": "_size-s_1yk1u_41",
    "size-m": "_size-m_1yk1u_53",
    "size-l": "_size-l_1yk1u_67"
  },p = t(s.badge, {
    variants: {
      isRound: {
        true: s.isRound
      },
      size: {
        xs: s["size-xs"],
        s: s["size-s"],
        m: s["size-m"],
        l: s["size-l"]
      },
      variant: {
        primary: s.primary,
        secondary: s.secondary,
        error: s.error
      }
    },
    defaultVariants: {
      isRound: !1,
      size: "m",
      variant: "primary"
    }
  }),g = ({
    children: r,
    className: a,
    isRound: e,
    size: i,
    variant: o,
    ..._
  }) => /* @__PURE__ */n(
    "span",
    {
      className: y(p({ isRound: e, size: i, variant: o }), a),
      ..._,
      children: r
    }
  );
export {
  g as B };